import { Component, signal, effect, inject, computed, OnInit } from '@angular/core';
import { TabsModule } from '@openng/optimus-ui/tabs';
import { SpecLotsAndModelsTabs } from '../../../models/spec-lots-and-models-tabs.enum';
import { NgClass } from '@angular/common';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { HeaderService, rxResourceFixed } from '@zayan-erp/shared';
import { SalesService } from '../../../services/sales.service';
import { LotType } from '@zayan-erp/shared';
import { of } from 'rxjs';

@Component({
  selector: 'lib-build-spec-and-model-details',
  imports: [TabsModule, NgClass, RouterOutlet],
  templateUrl: './build-spec-and-model-details.component.html'
})
export class BuildSpecAndModelDetailsComponent implements OnInit {
  #router = inject(Router);
  #activatedRoute = inject(ActivatedRoute);
  #salesService = inject(SalesService);
  #headerService = inject(HeaderService);

  LotType = LotType;

  activeTabIndex = signal<number>(0);
  SpecLotsAndModelsTabs = SpecLotsAndModelsTabs;
  selectedSpecLotId = signal<string | null>(this.#activatedRoute.snapshot.paramMap.get('specLotId') ?? null);

  specLotDetailsResource = rxResourceFixed({
    params: () => ({ specLotId: this.selectedSpecLotId(), refresh: this.#salesService.refreshTrigger() }),
    defaultValue: null,
    stream: ({ params }) => {
      if (params.specLotId) {
        return this.#salesService.readSpecLotDetails(params.specLotId);
      }
      return of(null);
    }
  });

  specLot = computed(() => this.specLotDetailsResource.value());

  constructor() {
    effect(() => {
      if (this.activeTabIndex() === 0) {
        this.#router.navigate(['sales/build-spec-model', this.selectedSpecLotId()!, 'overview'], {
          queryParamsHandling: 'preserve',
          replaceUrl: true
        });
      } else if (this.activeTabIndex() === 1) {
        this.#router.navigate(
          [
            'sales/build-spec-model',
            this.selectedSpecLotId()!,
            'options',
            this.selectedSpecLotId()!,
            this.specLot()?.selectedModel?.id!,
            this.specLot()?.selectedElevation?.id!
          ],
          {
            queryParamsHandling: 'preserve'
          }
        );
      }
    });
  }

  ngOnInit(): void {
    this.#headerService.setSearchConfig({
      showSearch: false
    });
  }

  onTabChange(index: number | string): void {
    const tabIndex = typeof index === 'string' ? parseInt(index, 10) : index;
    this.activeTabIndex.set(tabIndex);
  }
}
